import { useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { deleteFileRequest } from "@/services";

const DocumentFiles = ({
  files,
  reloadDocumentsList,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  // Synchronous guard: state updates aren't immediate, so a fast double-click
  // could otherwise fire a second (redundant) DELETE that 404s.
  const deletingRef = useRef(false);

  const handleDeleteClick = (doc) => {
    setDeleteTarget(doc);
    setDeleteError("");
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!deleteTarget || deletingRef.current) return;
    deletingRef.current = true;
    setDeleting(true);
    setDeleteError("");
    try {
      const res = await deleteFileRequest(deleteTarget.uuid);
      if (res?.success === false) {
        setDeleteError(
          (typeof res.error === "string" && res.error) ||
            "Failed to delete this document. Please try again."
        );
        return;
      }
      await reloadDocumentsList();
      setShowConfirm(false);
      setDeleteTarget(null);
    } catch (err) {
      console.error("Failed to delete document", err);
      setDeleteError("Failed to delete this document. Please try again.");
    } finally {
      setDeleting(false);
      deletingRef.current = false;
    }
  };

  return (
    <div>
      <div className="mt-2">
        {files.map((file) => (
          <div
            key={file.id}
            className="d-flex justify-content-between align-items-center border p-2 mb-1 rounded"
          >
            <a
              href={file.file}
              target="_blank"
              rel="noopener noreferrer"
              className="text-truncate"
              style={{ maxWidth: "70%" }}
            >
              {file.file_name || "View Document"}
            </a>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => handleDeleteClick(file)}
            >
              Delete
            </Button>
          </div>
        ))}
      </div>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete{" "}
          <b>{deleteTarget?.file_name || "this document"}</b>?
          {deleteError && (
            <div className="text-danger small mt-2">{deleteError}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete} disabled={deleting}>
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DocumentFiles;
